module.exports = __webpack_public_path__ + "img/所得税前.8fef710a.svg";